import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const UsdcIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/usdc-coin.png" style={style} />
}
